import type {
    IPagesReportTableMetrics,
    IPagesReportTableTab,
} from "app/pages/digital-marketing/keywords-campaigns/reports/pages-report/table/PagesReportTableTypes";
import {
    EPagesReportTableMetrics,
    EPagesReportTableTabs,
} from "app/pages/digital-marketing/keywords-campaigns/reports/pages-report/table/PagesReportTableTypes";
import { LAST_DAY_CLICKS_FIELDS } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/Table/TableUtils/RankTrackerTablesConsts";

export const KEYWORD_CHANGE_DECIMAL_ROUND_PAGES_REPORT = 1;

export const CLICKS_METRICS_DECIMAL_ROUND_PAGES_REPORT = 0;
export const CLICKS_CHANGE_DECIMAL_ROUND_PAGES_REPORT = 1;

export const AVG_POS_METRICS_DECIMAL_ROUND_PAGES_REPORT = 0;
export const AVG_POS_CHANGE_DECIMAL_ROUND_PAGES_REPORT = 0;

export const DEFAULT_POSITION_SORTING_PAGES_REPORT = "volume:p";
export const DEFAULT_KEYWORD_SORTING_PAGES_REPORT = "volume:k";
export const DEFAULT_CLICKS_SORTING_PAGES_REPORT = "volume:c";

export const EXPANDED_TABLE_ROW_HEIGHT = 41;
export const EXPANDED_WIDGET_HEIGHT = 590;
export const DEFAULT_SORTED_COLUMN = "volume" as const;

export const TABLE_TABS_TITLES: IPagesReportTableTab[] = [
    {
        name: EPagesReportTableTabs.ALL_RANKING,
        title: "seo.rankTracker.pagesReport.table.tab.rankingPages.title",
        iconName: "pages-per-visit",
    },
    {
        name: EPagesReportTableTabs.NEW_PAGES,
        title: "seo.rankTracker.pagesReport.table.tab.newPages.title",
        iconName: "sort-up",
    },
    {
        name: EPagesReportTableTabs.LOST_PAGES,
        title: "seo.rankTracker.pagesReport.table.tab.lostPages.title",
        iconName: "sort-down",
    },
];

export const tableMetricsPagesReport: IPagesReportTableMetrics[] = [
    {
        metricID: EPagesReportTableMetrics.KEYWORD,
        defaultSort: DEFAULT_KEYWORD_SORTING_PAGES_REPORT,
        tooltipKey: "seo.rankTracker.pagesReport.table.tab.keyword.tooltip",
        changeFilter: `simplePercentage:${KEYWORD_CHANGE_DECIMAL_ROUND_PAGES_REPORT}`,
        isMetricPercentage: false,
        isChangePercentage: false,
        lastDayKey: LAST_DAY_CLICKS_FIELDS.keyword,
        changeKey: `changeKeyword`,
        metricTitleKey: "seo.rankTracker.pagesReport.table.tab.keyword.header",
        firstLastDateTooltipKey: "seo.rankTracker.pagesReport.table.tab.keyword.firstLastCell.tooltip",
        metricAggregatedColumnNameKey: "seo.rankTracker.pagesReport.table.keywordColumn.header",
    },
    {
        metricID: EPagesReportTableMetrics.CLICKS,
        defaultSort: DEFAULT_CLICKS_SORTING_PAGES_REPORT,
        tooltipKey: "seo.rankTracker.pagesReport.table.tab.clicks.tooltip",
        metricTitleKey: "seo.rankTracker.pagesReport.table.tab.clicks.header",
        metricFilter: `abbrNumber:${CLICKS_METRICS_DECIMAL_ROUND_PAGES_REPORT}`,
        changeFilter: `simplePercentage:${CLICKS_CHANGE_DECIMAL_ROUND_PAGES_REPORT}`,
        isMetricPercentage: false,
        isChangePercentage: true,
        lastDayKey: LAST_DAY_CLICKS_FIELDS.clicks,
        changeKey: `changeClicks`,
        firstLastDateTooltipKey: "seo.rankTracker.pagesReport.table.tab.clicks.firstLastCell.tooltip",
        metricAggregatedColumnNameKey: "seo.rankTracker.pagesReport.table.clicksColumn.header",
    },
    {
        metricID: EPagesReportTableMetrics.POSITION,
        metricTitleKey: "seo.rankTracker.pagesReport.table.tab.position.header",
        defaultSort: DEFAULT_POSITION_SORTING_PAGES_REPORT,
        tooltipKey: "seo.rankTracker.pagesReport.table.tab.position.tooltip",
        metricFilter: `number:${AVG_POS_METRICS_DECIMAL_ROUND_PAGES_REPORT}`,
        changeFilter: `number:${AVG_POS_CHANGE_DECIMAL_ROUND_PAGES_REPORT}`,
        isMetricPercentage: false,
        isChangePercentage: false,
        lastDayKey: LAST_DAY_CLICKS_FIELDS.avgPosition,
        changeKey: `changeAvgPos`,
        firstLastDateTooltipKey: "seo.rankTracker.pagesReport.table.tab.firstLastCell.tooltip",
        metricAggregatedColumnNameKey: "seo.rankTracker.pagesReport.table.positionColumn.header",
    },
];
